(function () {
  if (window.tfAnnouncementCloseInit) return;
  window.tfAnnouncementCloseInit = true;

  var storageKey = "announcement_bar_closed";

  document.addEventListener("click", function (e) {
    var button = e.target.closest("[data-announcement-close]");
    if (!button) return;

    e.preventDefault();

    var bar = button.closest(".announcementbar-section");
    if (!bar) return;

    try {
      if (!(window.Shopify && window.Shopify.designMode)) {
        sessionStorage.setItem(storageKey, "true");
      }
    } catch (e) {}

    var sectionEl = bar.closest(".shopify-section");
    var barHeight = bar.offsetHeight;

    bar.style.overflow = "hidden";
    bar.style.transition = "margin-top 0.4s ease, opacity 0.4s ease";
    bar.style.marginTop = "-" + barHeight + "px";
    bar.style.opacity = "0";

    setTimeout(function () {
      if (sectionEl) {
        sectionEl.hidden = true;
      } else {
        bar.remove();
      }
    }, 400);
  });

  
})();